import { createUseStyles } from "react-jss";
import { ITheme } from "../../constants/theme";
import {
  BreakPointDesktop,
  BreakPointMobile,
  BreakPointTablet,
} from "../../constants/dimension";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    display: "flex",
    position: "fixed",
    top: 0,
    left: 0,
    boxSizing: "border-box",
    flexDirection: "column",
    height: "100%",
    overflow: "scroll",
    "-ms-overflow-style": "none",
    scrollbarWidth: "none",
    "&::-webkit-scrollbar": {
      display: "none",
    },
    paddingTop: 70,
    width: "100%",
    background: "#000",
    gap: theme.spacing.space16,
    [BreakPointDesktop]: {
      gap: theme.spacing.space48,
      justifyContent: "space-between",
      padding: `0 90px`,
      alignItems: "center",
      flexDirection: "row",
    },
  },
  background: {
    position: "fixed",
    width: "100%",
    height: "100%",
    zIndex: -1,
    top: 0,
    left: 0,
    objectFit: "cover",
  },
  header: {
    position: "fixed",
    top: theme.spacing.space12,
    left: theme.spacing.space8,
    cursor: "pointer",
    display: "flex",
    [BreakPointDesktop]: {
      borderRadius: 20,
      background: "rgba(255, 255, 255, 0.10)",
      backdropFilter: "blur(24.545454025268555px)",
      width: 96,
      height: 96,
      top: 40,
      left: 90,
      alignItems: "center",
      justifyContent: "center",
    },
  },
  iconHeader: {
    padding: theme.spacing.space8,
  },
  planWrapper: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    alignItems: "center",
    position: "relative",
    padding: `0 ${theme.spacing.space16}px`,
    boxSizing: "border-box",
    "&.header": {
      padding: "unset",
    },
    [BreakPointDesktop]: {
      padding: "unset",
      width: 540,
    },
  },
  planTitleWrapper: {
    textAlign: "center",
    [BreakPointDesktop]: {
      textAlign: "start",
    },
  },
  planFeatures: {
    borderRadius: 48,
    background: "rgba(255, 255, 255, 0.10)",
    display: "flex",
    padding: theme.spacing.space8,
    gap: theme.spacing.space8,
    width: "fit-content",
    [BreakPointMobile]: {
      padding: theme.spacing.space4,
    },
  },
  planItem: {
    borderRadius: 48,
    minWidth: 250,
    display: "flex",
    padding: `${theme.spacing.space16}px 0`,
    alignItems: "center",
    justifyContent: "center",
    "&.active": {
      background: "rgba(255, 255, 255, 0.10)",
    },
    [BreakPointMobile]: {
      width: "fit-content",
      minWidth: "unset",
      padding: `${theme.spacing.space12}px ${theme.spacing.space16}px`,
    },
  },
  planContent: {
    display: "flex",
    gap: theme.spacing.space16,
    marginTop: theme.spacing.space16,
    width: "100%",
    overflow: "hidden",
    [BreakPointDesktop]: {
      flexDirection: "column",
      marginTop: theme.spacing.space48,
    },
  },
  planTitle: {
    fontSize: 45,
    fontWeight: 600,
    lineHeight: "45px",
    color: "#fff",
    fontFamily: "Poppins",
    [BreakPointMobile]: {
      fontSize: 28,
      lineHeight: "28px",
    },
  },
  planDescription: {
    fontSize: 48,
    lineHeight: "48px",
    color: "#fff",
    fontFamily: "Poppins",
    fontWeight: 200,
    [BreakPointMobile]: {
      fontSize: 30,
      lineHeight: "30px",
    },
  },
  planContentIcon: {
    width: 54,
    height: 54,
    padding: theme.spacing.space8,
  },
  planContentItem: {
    display: "flex !important",
    gap: theme.spacing.space16,
    padding: `${theme.spacing.space16}px ${theme.spacing.space12}px`,
    alignItems: "center",
    [BreakPointDesktop]: {
      background: "rgba(255, 255, 255, 0.05)",
      borderRadius: 24,
      maxWidth: 380,
    },
    [BreakPointMobile]: {
      padding: 0,
      paddingLeft: theme.spacing.space16,
    },
  },
  planSlider: {
    height: 100,
    [BreakPointMobile]: {
      height: 68,
    },
  },
  planContentText: {
    width: "max-content",
  },
  planPayment: {
    borderRadius: "24px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: theme.spacing.space24,
    alignSelf: "stretch",
    padding: `0 48px`,
    marginTop: theme.spacing.space32,
    [BreakPointDesktop]: {
      border: "0.667px solid rgba(255, 255, 255, 0.10)",
      background: "rgba(255, 255, 255, 0.10)",
      padding: "60px 48px",
      marginTop: theme.spacing.space24,
    },
    [BreakPointMobile]: {
      gap: theme.spacing.space16,
      padding: "unset",
      paddingBottom: theme.spacing.space16,
    },
  },
  planPaymentTitle: {
    textAlign: "center",
    "& > p": {
      fontFamily: '"Poppins"',
      color: theme.colors.TextDefault,
      fontWeight: 700,
      fontSize: 32,
      lineHeight: "32px",
      [BreakPointDesktop]: {
        fontSize: 48,
        lineHeight: "48px",
      },
      [BreakPointMobile]: {
        fontSize: 28,
        lineHeight: "28px",
      },
    },
  },
  planPaymentPrice: {
    textAlign: "center",
  },
  getButton: {
    display: "flex",
    height: "80px",
    padding: "24px 64px 23.333px 64px",
    justifyContent: "center",
    alignItems: "flex-start",
    gap: "15.844px",
    borderRadius: "22369600px",
    background: "#1877EB",
    boxShadow: "0 20px 60px 0 rgba(24, 119, 235, 0.40)",
    fontSize: 24,
    fontWeight: 600,
    lineHeight: "32px",
    [BreakPointMobile]: {
      alignItems: "center",
      fontSize: 16,
      width: "100%",
      padding: `${theme.spacing.space16}px 0`,
      height: "unset",
      lineHeight: "16px",
    },
  },
  price: {
    color: theme.colors.TextGray,
    fontFamily: '"Poppins"',
    fontSize: "28px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "140%",
    textDecorationLine: "line-through",
  },
  backgroundImage: {
    position: "absolute",
    zIndex: -1,
    transform: "translate(-50%, -50%)",
    top: "50%",
    left: "50%",
    display: "none",
    [BreakPointDesktop]: {
      display: "block",
    },
  },
  blury: {
    position: "absolute",
    width: 400,
    height: 400,
    borderRadius: 100,
    background: "rgba(173, 70, 255, 0.15)",
    filter: "blur( 120px )",
    left: "-30%",
    bottom: "-30%",
    zIndex: 1,
    pointerEvents: "none",
    display: "none",
    [BreakPointDesktop]: {
      display: "block",
    },
  },
  planImage: {
    width: 360,
    marginTop: theme.spacing.space32,
    position: "relative",
    "&.isWithController": {
      marginBottom: theme.spacing.space32,
    },
    [BreakPointDesktop]: {
      display: "none",
    },
    [BreakPointMobile]: {
      width: 240,
      marginTop: theme.spacing.space16,
    },
  },
  mobileImage: {
    width: "100%",
  },
  controllerImage: {
    position: "absolute",
    transform: "translate(-50%, -50%)",
    width: 290,
    top: "70%",
    left: "50%",
    display: "none",
    [BreakPointDesktop]: {
      display: "block",
    },
  },
  controllerMobileImage: {
    width: 168,
    position: "absolute",
    transform: "translate(-50%, -50%)",
    top: "100%",
    left: "50%",
    zIndex: 1,
    [BreakPointMobile]: {
      width: 112,
    },
  },
  selected: {
    outline: "2px solid rgba(255, 255, 255, 0.80)",
    outlineOffset: 2,
  },
  flipkartLogo: {
    height: 30,
    [BreakPointMobile]: {
      height: 24,
    },
  },

  badgeContainer: {
    display: "flex",
    gap: theme.spacing.space4,
    alignItems: "center",
    borderRadius: 100,
    background: "linear-gradient(275deg, #64A4F2 4.58%, #166CD6 89.48%)",
    padding: `${theme.spacing.space8}px ${theme.spacing.space16}px`,
  },
  priceContainer: {
    display: "flex",
    alignItems: "baseline",
    gap: theme.spacing.space8,
  },
  originalPrice: {
    textDecorationLine: "line-through",
  },
  bottomBar: {
    boxSizing: "border-box",
    position: "fixed",
    width: "100%",
    left: 0,
    bottom: 0,
    background: "#1d1b1b",
    padding: `${theme.spacing.space8}px ${theme.spacing.space16}px`,
    [BreakPointDesktop]: {
      padding: `${theme.spacing.space24}px 90px`,
    },
    [BreakPointTablet]: {
      padding: `${theme.spacing.space16}px ${theme.spacing.space24}px`,
    },
  },
  content: {
    [BreakPointMobile]: {
      marginBottom: theme.spacing.space48,
    },
  },
}));
